import {
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  YoutubeIcon,
} from "Components/Icons";
import trusted from "../../Assets/homev2/footer-trusted-partner.png";

import SimpleNavbar from "Components/SimpleNavbar";
import BookingSection from "Components/LeadCare/BookingSection";

const ADThankYouPage = () => {
  return (
		<div className="w-full flex flex-col">
			{/* <section className="bg-black w-full h-20 border-b border-b-gray-300 border-opacity-20 flex items-center justify-center">
        <img src={require('Assets/logo.png')} alt="Salesmrkt" height={30} width={160} />
      </section> */}

			<section
				style={{ backgroundImage: "url('/bg-gradient-leadcare.png')" }}
				className="bg-cover bg-no-repeat text-black flex flex-col w-full justify-center items-center p-5 pt-20"
			>
				<div className="text-[45px] font-bold mb-2 text-center sm:text-left">
					Thank You for Your Submission
				</div>
				<div className="text-center sm:text-left">
					Schedule a call with us to discuss your video and content needs.
				</div>

				<BookingSection />
				<div className="flex flex-col max-w-[700px]">
					<img
						src={require("Assets/homev2/hero-image.png")}
						alt=""
						className="mx-10"
					/>
					<div className="bg-black relative w-full rounded-full py-7 px-5 flex flex-row items-center justify-center gap-5 lg:gap-10">
						<div className="uppercase tracking-widest  text-white lg:text-[20px]">
							Find us on
						</div>
						<div className="flex  items-center gap-2  lg:gap-5  text-white">
							<a
								href="https://www.youtube.com/@salesmrkt"
								target="_blank"
								rel="noreferrer"
							>
								<YoutubeIcon />
							</a>
							<a
								href="https://www.instagram.com/salesmrkt_/"
								target="_blank"
								rel="noreferrer"
							>
								<InstagramIcon />
							</a>
							<a
								href="https://www.facebook.com/Salesmrkt.B2B.Marketplace"
								target="_blank"
								rel="noreferrer"
							>
								<FacebookIcon />
							</a>
							<a
								href="https://www.linkedin.com/company/sales-mrkt/"
								target="_blank"
								rel="noreferrer"
							>
								<LinkedInIcon />
							</a>
						</div>
						<img
							src={trusted}
							alt="Trusted Partner"
							className="max-w-[40px] lg:max-w-[60px] absolute right-5 top-1/2 -translate-y-1/2"
						/>
					</div>
				</div>
			</section>
			<SimpleNavbar />
		</div>
	);
};

export default ADThankYouPage;
